
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/machine-learning-solutions/[slug]",
      function () {
        return require("private-next-pages/machine-learning-solutions/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/machine-learning-solutions/[slug]"])
      });
    }
  